import { api } from 'src/services/api';

export class CustomersService {
  static async getCustomers() {
    return api.get(`/supplier/supplier/referrals`);
  }

  static async updateReminderDate(retailer_id) {
    return api.post(`/supplier/supplier/referrals/reminder`, {
      retailer_id,
    });
  }

  static async createReferralCustomer({ name, email, phone, cnpj, client }) {
    return api.post('supplier/indicar-lojistas', {
      name,
      email,
      phone,
      cnpj,
      client,
    });
  }

  static async getPresignedUploadData(fileType) {
    return api
      .get(`supplier/supplier/upload-list/retailers/${fileType}`)
      .then(response => response.data);
  }
}
